import { useState } from "react";

export default function ProvReciproModal({ provinces, onOk, onAnnuler, showPopup }) {
  const [prov, setProv] = useState("");
  const liste = (provinces || []).filter(p => (p.value || "").trim() !== "QC");

  const handleOk = () => {
    if (!prov.trim()) {
      showPopup?.("Svp veuillez sélectionner une province.", "info", "Réciprocité");
      return;
    }
    onOk(prov.trim());
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 }}
         onClick={onAnnuler}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 400, maxWidth: "94vw" }}
           onClick={e => e.stopPropagation()}
           data-testid="prov-recipro-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15,
                      display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>RÉCIPROCITÉ — AUTRE PROVINCE</span>
          <button className="win-modal-close" onClick={onAnnuler} data-testid="prov-recipro-btn-x">×</button>
        </div>
        <div style={{ padding: 20, fontSize: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
            <span style={{ fontWeight: 600 }}>Province :</span>
            <select className="win-input" value={prov} onChange={e => setProv(e.target.value)}
                    style={{ flex: 1, fontSize: 13 }} data-testid="prov-recipro-select">
              <option value=""></option>
              {liste.map(p => (
                <option key={p.value} value={p.value}>{p.value}{p.description ? ` — ${p.description}` : ""}</option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button className="win-btn" onClick={onAnnuler} data-testid="prov-recipro-btn-annuler">Annuler</button>
            <button className="win-btn" onClick={handleOk} style={{ fontWeight: "bold" }}
                    data-testid="prov-recipro-btn-ok">OK</button>
          </div>
        </div>
      </div>
    </div>
  );
}
